var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticStyle: { width: "100%" },
    style: { height: _vm.autoHeight - 100 + "px" },
    attrs: { id: "container" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }